import React from 'react';
import type { IconType } from 'react-icons';

interface AuthButtonProps {
  title: string;
  loadingTitle: string;
  loading: boolean;
  disabled: boolean;
  icon?: IconType;
}

export const AuthButton: React.FC<AuthButtonProps> = ({
  title,
  loadingTitle,
  loading,
  disabled,
  icon: Icon,
}) => (
  <button
    type="submit"
    className={`authButton ${loading || disabled ? 'disabled' : 'active'}`}
    disabled={disabled || loading}
  >
    {loading ? loadingTitle : title}
    {!loading && Icon && <Icon size={24} className="ml-2" />}
  </button>
);
